import { DadosPii } from '@interfaces/analysis/campaign-pii-data';
import { SelectOptionInterface } from '../../../../../@types/entity/interface/select-option-interface';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import Select from 'react-select';

interface PropsModalCampaignPiiData {
  showModalPii: boolean;
  closeModalPii: () => void;
  meliOptions: SelectOptionInterface[] | undefined;
  confirmActionFunction: (dadosPii: DadosPii) => void;
}

function getTodayDateTimeLocalMin() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}T00:00`;
}

export const ModalCampaignPiiData: React.FC<PropsModalCampaignPiiData> = ({
  showModalPii,
  closeModalPii,
  meliOptions,
  confirmActionFunction,
}) => {
  const [codigoMeli, setCodigoMeli] = useState<SelectOptionInterface | null>(null);
  const [dataAgendamento, setDataAgendamento] = useState('');
  const [inbound, setInbound] = useState('');
  const minDataAgendamento = getTodayDateTimeLocalMin();
  const dataAgendamentoInvalida = dataAgendamento !== '' && dataAgendamento < minDataAgendamento;

  useEffect(() => {
    if (showModalPii) {
      setCodigoMeli(null);
      setDataAgendamento('');
      setInbound('');
    }
  }, [showModalPii]);

  function handleInboundChange(value: string) {
    setInbound(value.replace(/\D/g, '').slice(0, 15));
  }

  function handleConfirm() {
    if (dataAgendamentoInvalida) return;

    confirmActionFunction({
      codigoMeli: codigoMeli?.value !== undefined && codigoMeli?.value !== null ? String(codigoMeli.value) : null,
      dataAgendamento: dataAgendamento !== '' ? dataAgendamento : null,
      inbound: inbound !== '' ? inbound : null,
    });
  }

  return (
    <Modal show={showModalPii} onHide={closeModalPii} size="lg" centered={true} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Dados PII</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Código MELI:</Form.Label>
              <Select
                value={codigoMeli}
                options={meliOptions}
                onChange={(value) => setCodigoMeli(value as SelectOptionInterface | null)}
                placeholder="Selecione o código MELI"
                isClearable
                isDisabled={meliOptions === undefined}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Data Agendamento:</Form.Label>
              <Form.Control
                type="datetime-local"
                min={minDataAgendamento}
                value={dataAgendamento}
                isInvalid={dataAgendamentoInvalida}
                onChange={(event) => setDataAgendamento(event.currentTarget.value)}
              />
              <Form.Control.Feedback type="invalid">A data de agendamento deve ser hoje ou uma data futura.</Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Inbound:</Form.Label>
              <Form.Control
                type="text"
                inputMode="numeric"
                maxLength={15}
                value={inbound}
                onChange={(event) => handleInboundChange(event.currentTarget.value)}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" size="sm" onClick={handleConfirm} disabled={dataAgendamentoInvalida}>
          Continuar
        </Button>
        <Button variant="danger" size="sm" onClick={closeModalPii}>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

